<template>
  <a class="position-relative">
    <span style="font-size: 0"
          @click="notificationsPressed">
      <BellSvg class="pointer"/>
    </span>
    <span class="notification-bubble"
          v-if="notificationsCounter > 0">
      {{ notificationsCounter }}
    </span>
    <b-dropdown menu-class="mt-3 header-notifications"
                right
                ref="dropdown"
                variant="link"
                no-caret>
      <div>
        <div class="border-bottom"
             v-if="notificationsCounter > 0 && more">
          <a @click="readAll"
             class="text-center d-block p-2 pointer text-muted text-underlined font-weight-normal">
            {{ $t('read_all') }}
          </a>
        </div>
        <div v-for="(n, nind) in notifications"
             :key="`notif-${n.id}`"
             class="dropdown-item">
          <NotificationTeaser :notification="n"
                              @onShowTask="onShowTask"
                              @onDelete="notificationDeleted(nind)"
                              :class="{'border-bottom': (nind + 1) < notifications.length }"/>
        </div>
        <div v-if="loaded && !notifications.length"
             class="dropdown-item">
          {{ $t('no_notifications') }}
        </div>
        <div v-if="more">
          <ScrollToEventElement @visible="loadMore">
            <a v-if="more"
               class="text-center p-3 d-block"
               @click="loadMore">
              <RefreshSvg class="pointer"/>
            </a>
          </ScrollToEventElement>
        </div>
      </div>
    </b-dropdown>
  </a>
</template>

<script>
import BellSvg from '@/assets/svg-vue/header/bell.svg'
import RefreshSvg from '@/assets/svg-vue/general/refresh2.svg'
import {mapState} from "vuex"
import { EloquentService } from "@/services/api/eloquent.api.service"
import {MarketingService} from "@/services/api/marketing.api.service"
import NotificationTeaser from "@/components/parts/header/NotificationTeaser"
import ScrollToEventElement from "@/components/parts/general/ScrollToEventElement.vue"
import {copyObject} from "@/extensions/prototypes/prototypes"

export default {
  name: "HeaderNotifications",
  components: {
    ScrollToEventElement,
    NotificationTeaser,
    BellSvg,
    RefreshSvg
  },
  data() {
    return {
      notifications: [],
      page: 1,
      loaded: false,
      loading: false,
      more: false,
      timer: null,
      allRead: false
    }
  },
  computed: {
    ...mapState({
      headerCounters: state => state.auth.headerCounters,
      user: state => state.auth.user
    }),
    notificationsCounter() {
      return this.headerCounters.unread
    }
  },
  methods: {
    notificationsPressed() {
      if(this.$refs.dropdown.visible) {
        if(this.timer) clearTimeout(this.timer)
        this.$refs.dropdown.hide()
        return
      }
      // if(this.loaded) {
      //   this.$refs.dropdown.show()
      //   return
      // }
      this.page = 1
      this.notifications = []
      this.load()
    },
    loadMore() {
      if(this.loading) return
      this.page++
      this.load()
    },
    load() {
      this.loading = true
      EloquentService.dataTable('notification', this.page, {
        condition: {
          recipient_id: this.user.id,
          show_in_header: 1,
          sent_at: 'whereNotNull'
        },
        order: 'sent_at',
        sort: 'desc',
        pagination:  16,
      }).then(res => {
        this.notifications = this.notifications.concat(res.data.result.data)
        this.more = res.data.result.current_page < res.data.result.last_page
        this.loading = false
        this.loaded = true
        this.$refs.dropdown.show()
        this.timer = setTimeout(() => {
          let ids = this.notifications.filter(s => !s.is_read).map(s => s.id)
          if(ids.length) {
            MarketingService.readNotifications(ids).then(res => {
              if(!res.data) return
              this.notifications.forEach(item => {
                if(ids.includes(item.id)) item.is_read = true
              })
              this.$store.commit('incrementHeaderUpdateCounter')
            })
          }
        }, 2000)
      })
    },
    notificationDeleted(index) {
      setTimeout(() => {
        this.notifications.splice(index, 1)
      }, 20)
    },
    async readAll() {
      if(this.allRead) return
      try {
        this.allRead = true
        await MarketingService.readNotifications(['all'])
        this.$store.commit('incrementHeaderUpdateCounter')
      } catch (e) {
        console.log(e)
      } finally {
        this.allRead = false
      }
    },
    async onShowTask(taskId) {
      const task = await EloquentService.show('task', taskId)
      if(!task?.data) return
      this.$store.commit('setTask', copyObject(task.data))
      this.$bvModal.show('task-show-modal')
    }
  }
}
</script>

<style scoped>
.notification-bubble {
  top: 0;
  left: 12px;
}
</style>
